export const LINKEDIN_URL = "https://www.linkedin.com/showcase/aiatsbeater/";
export const SITE_URL = "https://getinterviewed.org";

// Opens LinkedIn's post composer with the text filled in, and copies it as a fallback.
export function shareOnLinkedIn(text) {
  window.open(`https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(text)}`, "_blank", "noopener,noreferrer");
  return navigator.clipboard?.writeText(text).then(() => true).catch(() => false) ?? Promise.resolve(false);
}
